// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Xk-z","trustedRetailerTooltipWrapper":"Yk-z"};